import React from 'react';
import { Form, Row, SonForm, SubmitButton, Textarea, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AxiosResponse } from 'axios';

type RejectProposalForm = {
  form: SonForm<any>;
  onSuccess?: (response: AxiosResponse) => void;
};

export function RejectProposalForm({ form, onSuccess }: RejectProposalForm) {
  const { t } = useSonTranslation('ProposedPagePublicationInfo');

  const { formProps, fetchState, params } = useForm({ form, onSuccess });
  const comment = params.findByName('comment');

  return (
    <Form id="reject-proposal-form" {...formProps}>
      <Row>
        <Textarea label={t(`rejectProposal.comment`)} param={comment} />
      </Row>
      <SubmitButton
        buttonLabel={t(`rejectProposal.saveChanges`)}
        messageSending={t('rejectProposal.status.sending')}
        messageForward={t('rejectProposal.status.forward')}
        messageSuccess={t('rejectProposal.status.success')}
        messageFail={t('rejectProposal.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
